import { lazy, Suspense } from "react";
import Loader from "../custom/loader/main";

const Main = lazy(() => import("../components/approval/viewMasterResult/main"));

const ViewMasterResult = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default ViewMasterResult;
